import _extends from "@babel/runtime/helpers/extends";import _slicedToArray from "@babel/runtime/helpers/slicedToArray";import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";var _excluded = ["url"];import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

export var StyledSvg = styled.div.withConfig({ displayName: "Svg__StyledSvg", componentId: "sc-13dkdtw-0" })([""]);

/**
 * @typedef SvgProps
 * @property {string} url The url to fetch the SVG.
 */

/** @type {(props: SvgProps & React.HTMLAttributes<HTMLDivElement>) => JSX.Element} */
export function Svg(_ref) {var url = _ref.url,otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(''),_useState2 = _slicedToArray(_useState, 2),data = _useState2[0],setData = _useState2[1];

  useEffect(function () {
    fetch(url).
    then(function (response) {return response.text();}).
    then(setData);
  }, [url]);

  return /*#__PURE__*/(
    React.createElement(StyledSvg, _extends({
      dangerouslySetInnerHTML: { __html: data } },
    otherProps)
    ));

}
//# sourceMappingURL=Svg.js.map